var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "700" },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c(
                "v-toolbar-title",
                {
                  staticStyle: {
                    "font-size": "17px",
                    "margin-left": "10px !important"
                  }
                },
                [_vm._v("Patente: " + _vm._s(_vm.patente))]
              ),
              _c(
                "v-btn",
                {
                  staticStyle: { "margin-left": "auto" },
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      _vm.show = false
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card",
            { attrs: { "max-height": "500", id: "bodyDialogInfo" } },
            _vm._l(_vm.infoItems, function(item) {
              return _c(
                "div",
                {
                  key: item.index,
                  staticClass: "itemInfoDiv",
                  staticStyle: { width: "700px" }
                },
                [
                  _c("div", { staticStyle: { margin: "0px" } }, [
                    _c("img", {
                      staticStyle: { width: "350px", height: "350px" },
                      attrs: { src: _vm.link + item.value }
                    })
                  ]),
                  _c("divider")
                ],
                1
              )
            }),
            0
          )
        ],
        1
      ),
      _c("div", [
        _c(
          "div",
          {
            staticClass: "flex sm10 md10",
            staticStyle: { "margin-top": "1%" }
          },
          [
            _c(
              "FormFieldsContainer",
              [
                _c(
                  "v-flex",
                  { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", md3: "" } },
                      [
                        _c("v-autocomplete", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "tfClass",
                          attrs: {
                            items: _vm.formFields.patent.items,
                            label: _vm.formFields.patent.label,
                            "item-text": "__nom_flota",
                            "item-value": "cod_flota",
                            "data-vv-name": "patenteRequerida",
                            "error-messages": _vm.errors.collect(
                              "patenteRequerida"
                            ),
                            required: "",
                            multiple: ""
                          },
                          on: { change: _vm.confirmFlotas },
                          scopedSlots: _vm._u([
                            {
                              key: "prepend-item",
                              fn: function() {
                                return [
                                  _c(
                                    "v-list-tile",
                                    [
                                      _c("v-checkbox", {
                                        attrs: { label: "Seleccionar todos" },
                                        on: {
                                          change: function($event) {
                                            return _vm.selectAllFlota()
                                          }
                                        },
                                        model: {
                                          value: _vm.checkAllFlotas,
                                          callback: function($$v) {
                                            _vm.checkAllFlotas = $$v
                                          },
                                          expression: "checkAllFlotas"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("v-divider")
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "selection",
                              fn: function(ref) {
                                var item = ref.item
                                var index = ref.index
                                return [
                                  index === 0
                                    ? _c("v-chip", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.textoComprimido(
                                                item.__nom_flota
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  index === 1
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "grey--text text-caption",
                                          staticStyle: { "font-size": "0.75em" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  (+" +
                                              _vm._s(
                                                _vm.formFields.patent.value
                                                  .length - 1
                                              ) +
                                              ")\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.formFields.patent.value,
                            callback: function($$v) {
                              _vm.$set(_vm.formFields.patent, "value", $$v)
                            },
                            expression: "formFields.patent.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", md3: "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.formFields.patente.items,
                            label: _vm.formFields.patente.label,
                            "item-text": "patente_vehiculo",
                            "item-value": "cod_vehiculo",
                            multiple: ""
                          },
                          on: { change: _vm.confirmVehiculos },
                          scopedSlots: _vm._u([
                            {
                              key: "prepend-item",
                              fn: function() {
                                return [
                                  _c(
                                    "v-list-tile",
                                    [
                                      _c("v-checkbox", {
                                        attrs: { label: "Seleccionar todos" },
                                        on: {
                                          change: function($event) {
                                            return _vm.selectAllVehiculos()
                                          }
                                        },
                                        model: {
                                          value: _vm.checkAllVehiculos,
                                          callback: function($$v) {
                                            _vm.checkAllVehiculos = $$v
                                          },
                                          expression: "checkAllVehiculos"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("v-divider")
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "selection",
                              fn: function(ref) {
                                var item = ref.item
                                var index = ref.index
                                return [
                                  index === 0
                                    ? _c("v-chip", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.textoComprimido(
                                                item.patente_vehiculo
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  index === 1
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "grey--text text-caption",
                                          staticStyle: { "font-size": "0.75em" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  (+" +
                                              _vm._s(
                                                _vm.formFields.patente.value
                                                  .length - 1
                                              ) +
                                              ")\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.formFields.patente.value,
                            callback: function($$v) {
                              _vm.$set(_vm.formFields.patente, "value", $$v)
                            },
                            expression: "formFields.patente.value"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "v-flex",
                  { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", md3: "" } },
                      [
                        _c("DateComponent", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "tfClass",
                          attrs: {
                            label: _vm.formFields.dateStart.label,
                            "data-vv-name": "fechaRequerida",
                            "error-messages": _vm.errors.collect(
                              "fechaRequerida"
                            ),
                            max: _vm.fechaMaxima,
                            required: ""
                          },
                          model: {
                            value: _vm.formFields.dateStart.value,
                            callback: function($$v) {
                              _vm.$set(_vm.formFields.dateStart, "value", $$v)
                            },
                            expression: "formFields.dateStart.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", md3: "" } },
                      [
                        _c("TimeComponent", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "tfClass",
                          attrs: {
                            label: _vm.formFields.timeStart.label,
                            "data-vv-name": "horaRequerida",
                            "error-messages": _vm.errors.collect(
                              "horaRequerida"
                            ),
                            required: ""
                          },
                          model: {
                            value: _vm.formFields.timeStart.value,
                            callback: function($$v) {
                              _vm.$set(_vm.formFields.timeStart, "value", $$v)
                            },
                            expression: "formFields.timeStart.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", md3: "" } },
                      [
                        _c("DateComponent", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "tfClass",
                          attrs: {
                            label: _vm.formFields.dateEnd.label,
                            "data-vv-name": "fechaFinRequerida",
                            "error-messages": _vm.errors.collect(
                              "fechaFinRequerida"
                            ),
                            max: _vm.fechaMaxima,
                            required: ""
                          },
                          model: {
                            value: _vm.formFields.dateEnd.value,
                            callback: function($$v) {
                              _vm.$set(_vm.formFields.dateEnd, "value", $$v)
                            },
                            expression: "formFields.dateEnd.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", md3: "" } },
                      [
                        _c("TimeComponent", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "tfClass",
                          attrs: {
                            label: _vm.formFields.timeEnd.label,
                            "data-vv-name": "horaFinRequerida",
                            "error-messages": _vm.errors.collect(
                              "horaFinRequerida"
                            ),
                            required: ""
                          },
                          model: {
                            value: _vm.formFields.timeEnd.value,
                            callback: function($$v) {
                              _vm.$set(_vm.formFields.timeEnd, "value", $$v)
                            },
                            expression: "formFields.timeEnd.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center"
                        },
                        attrs: { sm3: "", md3: "" }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "btn-crear",
                            staticStyle: { margin: "5%" },
                            attrs: { color: "#FFE700" },
                            on: { click: _vm.handleClick }
                          },
                          [
                            _c("v-icon", { attrs: { color: "#27488e" } }, [
                              _vm._v("search")
                            ]),
                            _vm._v("Filtrar\n            ")
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "btn-crear",
                            staticStyle: { margin: "5%" },
                            attrs: { color: "#FFE700" },
                            on: { click: _vm.handleClear }
                          },
                          [
                            _c("v-icon", { attrs: { color: "#27488e" } }, [
                              _vm._v("clear")
                            ]),
                            _vm._v("Limpiar\n            ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticStyle: { width: "50%" } },
        [
          _c("v-text-field", {
            staticStyle: { width: "70%" },
            attrs: {
              label: "Buscar...",
              "single-line": "",
              "hide-details": ""
            },
            on: { input: _vm.handleSearch },
            model: {
              value: _vm.search,
              callback: function($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "bodyDiv" }, [
        _c(
          "div",
          { staticClass: "gridcard rounded-card" },
          [
            _c("GridComponent", {
              ref: "gridComponent",
              staticClass: "ag-theme-material",
              attrs: { id: "gridComponent", gridOptions: _vm.gridOptions }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }